import React from "react";

export const ShortArrowGray = () =>
  <svg width="14" height="48" viewBox="0 0 14 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7 0L7 39" stroke="#6C707E" stroke-width="2"/>
    <path d="M7 48L2.66987 38.25H11.3301L7 48Z" fill="#6C707E"/>
  </svg>

